import { createSlice  } from "@reduxjs/toolkit";

const ticketSlice = createSlice({
    name: "ticket",
    initialState:{
        tickets: [],
        isLoading: false,
        error: "",
        replyTicketError: "",
        searchTicketList: [],
        selectedTicket: {},
        replyMsg: "",
    },
    reducers: {

        fetchTicketLoading: (state) => {
            state.isLoading = true;
        },

        fetchTicketSuccess: (state, action) => {
            state.tickets = action.payload;
            state.searchTicketList = action.payload;
            state.isLoading = false;
        },

        fetchTicketFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },

        searchTickets: (state, { payload }) => {
            state.searchTicketList = state.tickets.filter((row) => {
              if (!payload) return row;
      
              return row.subject.toLowerCase().includes(payload.toLowerCase());
            });
        },

        fetchSingleTicketLoading: (state) => {
            state.isLoading = true;
        },
        
        fetchSingleTicketSuccess: (state, { payload }) => {
            state.selectedTicket = payload;
            state.isLoading = false;
            state.error = "";
        },
        
        fetchSingleTicketFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },

        replyTicketLoading: (state) => {
            state.isLoading = true;
        },
          
        replyTicketSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.error = "";
            state.replyMsg = payload;
        },
          
        replyTicketFail: (state, { payload }) => {
            state.isLoading = false;
            state.replyTicketError = payload;
        },

        closeTicketLoading: (state) => {
            state.isLoading = true;
        },
          
        closeTicketSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.error = "";
            state.replyMsg = payload;
        },
          
        closeTicketFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
          
        resetResponseMsg: (state) => {
            state.isLoading = false;
            state.replyTicketError = "";
            state.replyMsg = "";
        },
        
    }
})

export const { 
    fetchTicketLoading, fetchTicketSuccess, fetchTicketFail,
    searchTickets, fetchSingleTicketLoading, fetchSingleTicketSuccess,
    fetchSingleTicketFail, replyTicketLoading, replyTicketSuccess,
    replyTicketFail, closeTicketLoading, closeTicketSuccess,
    closeTicketFail, resetResponseMsg,
} = ticketSlice.actions;

export default ticketSlice.reducer;